// extracted by mini-css-extract-plugin
export default {"education":"Education_education__A9Aki","pageTitle":"Education_pageTitle__0mMj5"};